<template>    
    <div v-if="item && item.quantity_per_box" class="product-filters-container">
        <div class="product-single-filter" style="flex-direction: column; align-items: start">
            <c-label>Unidade:</c-label><br>
            <grid-size>
                <ul style="margin-bottom: 0.5rem">
                    <li
                        v-for="(un, key) in conversionUnits"
                        :key="key"
                        :class="{ 'active-size': conversionUnitWhenSellingWithClosedBox == un.value }"
                        @click="setConversionUnit(un)"
                    >
                        <span>{{ un.label }}</span>
                    </li>
                </ul>
            </grid-size>
            <c-span v-if="conversionUnitWhenSellingWithClosedBox == 'CX'">
                <strong>
                    {{ conversionText }}
                </strong>
            </c-span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { CLabel, CSpan } from '../Styles/Components/styled'
import { CGridSize } from '../Styles/Product/styled'

export default {
    name: 'ProductOptionsConversionUnity',
    props: {
        item: {
            required: true
        },
    },
    components: {
        'c-label': CLabel,
        'c-span': CSpan,
        'grid-size': CGridSize,
    },
    methods: {
        ...mapActions("products", [
            "setConversionUnitWhenSellingWithClosedBox"
        ]),
        setConversionUnit(un) {
            this.setConversionUnitWhenSellingWithClosedBox(un.value)
        },
        formatMeasureLabel(label, quantity) {
            let measure = String(label ?? '').trim()
            if(!measure) {
                return ''
            }
            if(measure.length <= 3 && measure == measure.toUpperCase()) {
                return measure
            }
            measure = measure.toLowerCase()
            if(Number(quantity) == 1 || measure.endsWith('s')) {
                return measure
            }
            return `${measure}s`
        },
    },
    computed: {
        ...mapState("products", [
            "numberOfBoxesSelected",
            "conversionUnitWhenSellingWithClosedBox"
        ]),
        conversionUnits() {
            return [
                { label: 'UND', value: 'UND' },
                { label: this.closedBoxUnitAbbreviation, value: 'CX' },
            ]
        },
        closedBoxUnitAbbreviation() {
            return this.item?.closed_box_unit_measure ?? 'CX'
        },
        closedBoxUnitLabel() {
            return this.formatMeasureLabel(
                this.item?.closed_box_unit_measure_description ?? this.item?.closed_box_unit_measure ?? 'CAIXA',
                this.numberOfBoxesSelected
            )
        },
        baseUnitLabel() {
            return this.formatMeasureLabel(
                this.item?.med_desc ?? this.item?.pro_sigla_medida ?? 'UNIDADE',
                this.item.quantity_per_box * this.numberOfBoxesSelected
            )
        },
        conversionText() {
            let unitQuantity = this.item.quantity_per_box * this.numberOfBoxesSelected
            let verb = Number(this.numberOfBoxesSelected) > 1 ? 'são' : 'é'
            return `${this.numberOfBoxesSelected} ${this.closedBoxUnitLabel} ${verb} ${unitQuantity} ${this.baseUnitLabel}.`
        }
    }
}
</script>

<style scoped>
ul {
    display: flex;
}
</style>
